
import Vue from "vue";
export default Vue.extend({
    name: "current-monitor",
    props: ["monitorProps","monitorIdHash"],
    data(){
        return {
            svgContent: "",
        }
    },
    methods: {
        currentMonitorProps():string[]{
            return this.monitorProps(this.monitorIdHash());
        },
        bgImage(n:string):string{
            return require('@/assets/monitors/'+n+'.svg');
        },
        dammyBg(n:string):string{
            //return require('@/assets/temp/bg/'+n+'.svg');
            return "";
        },
        loadSvg():void{
            fetch(this.bgImage(this.monitorProps[5])).then((res) => {
                res.text().then((html) => {
                  this.svgContent = html;
                  this.setSvgSize();                 
                });
            });
        },
        setSvgSize():void{
            let svgelm = document.querySelector<HTMLInputElement>("#js-current-monitor svg");
            //console.log(svgelm);
            if(svgelm==null){
                setTimeout(() => this.setSvgSize(),1);
            }else{
                //document.querySelector(".monitorFade01")?.addEventListener("animationend",this.toggleAnimation);
                let container = document.querySelector<HTMLInputElement>(".current-monitor");
                if(container){
                    container.style.width = svgelm.getAttribute("width")+"rem";
                    container.style.height = svgelm.getAttribute("height")+"rem";
                }
            }

        },
        toggleAnimation():void{
            console.log("animend");
            let target = document.querySelector(".monitorFade01");
            if(target){
                if(target.classList.contains("out")){
                    console.log("animend remove");
                    target.classList.remove("out");
                    target.addEventListener("animationend",this.toggleAnimation);
                }else{
                    console.log("animend add");
                    target.addEventListener("animationend",this.toggleAnimation);
                    target.classList.add("out");
                  
                }
            }
        },
        confirmPosition(){
            setTimeout(() => {
                let mainContent = document.getElementById('main-content');
                if(mainContent){
                    mainContent.style.cssText 
                    =    mainContent.style.cssText + "background-image:url('"+this.dammyBg(this.monitorProps[0])+"')";
                }
            }, 2000);
        },
    },
    mounted: function(){
        this.loadSvg();
        //this.setSvgSize();
        //this.confirmPosition();
    },
    computed:{
        styles(){
            return {
                "--top" : this.monitorProps[3] + "rem",
                "--left" : this.monitorProps[4] + "rem",
            }
        }
    }
});
